const EMAIL_DOMAIN_TO_CLIENT_CODE_MAP = new Map([
    ["brighttalk.com", "BRT"],
    ["techtarget.com", "TET"],
    ["perpperfield.com", "PEF"],
    ["pricer.com", "PRC"],
]);

export function getClientCodeFromEmail(email) {
    const pos = email.indexOf("@");
    if(email.indexOf("@") <= 0) return "";
    const emailDomain = email.substring(pos+1);
    // NEW CODE
    const emailBreaks = emailDomain.split('.');
    return emailBreaks[0].toUpperCase();
    //

    // OLD RETURN
    // return EMAIL_DOMAIN_TO_CLIENT_CODE_MAP.get(emailDomain)
}